"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELEMENT_OPTIONS = exports.ALIGN_OPTIONS = exports.WEIGHT_OPTIONS = exports.SIZE_OPTIONS = exports.TYPE_OPTIONS = void 0;
var TYPE_OPTIONS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  CRITICAL: "critical",
  WHITE: "white"
};
exports.TYPE_OPTIONS = TYPE_OPTIONS;
var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var WEIGHT_OPTIONS = {
  NORMAL: "normal",
  BOLD: "bold"
};
exports.WEIGHT_OPTIONS = WEIGHT_OPTIONS;
var ALIGN_OPTIONS = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  JUSTIFY: "justify"
};
exports.ALIGN_OPTIONS = ALIGN_OPTIONS;
var ELEMENT_OPTIONS = {
  P: "p",
  SPAN: "span",
  DIV: "div"
};
exports.ELEMENT_OPTIONS = ELEMENT_OPTIONS;